import DailyDataTableController from './daily-data-table.controller';

const template = require<string>('./daily-data-table.html');

const dailyDataTableComponent:ng.IComponentOptions = {
  bindings: {
    'dailyData': '<',
    'stationId': '<',
    'isVirtualStation': '<',
    'loadJournal': '&'
  },
  controller: DailyDataTableController,
  template
};
export default dailyDataTableComponent;



/** WEBPACK FOOTER **
 ** ./app/operational/journal/daily-data-table.component.ts
 **/